import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { createStyles, withStyles } from '@material-ui/styles';
import { toCssValue } from '@topconagriculture/theme';
import cn from 'classnames';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { compose, defaultProps, pure, withHandlers } from 'recompose';
import { Text } from '../Text';
const styles = (theme) => createStyles({
    title: {
        flex: 1,
    },
    root: {
        position: 'relative',
        width: '100%',
        height: theme.layout.header.menu,
        backgroundColor: theme.color.background.light,
    },
    menuContainer: {
        display: 'inline-flex',
        justifyContent: 'center',
        margin: '0 auto',
        minHeight: theme.layout.header.menu,
        alignItems: 'flex-end',
        flexGrow: 1,
    },
    menuSection: {
        marginLeft: 10,
        marginRight: 10,
        textAlign: 'center',
    },
    menuLink: {
        color: theme.color.font.dark,
        fontSize: theme.font.size.medium,
        textTransform: 'uppercase',
        textDecoration: 'none',
        padding: toCssValue([3, 15, 3, 15]),
        display: 'flex',
        alignItems: 'center',
        height: 45,
        borderBottom: `5px solid transparent`,
        '&.selected': {
            borderBottom: `5px solid ${theme.components.menu.colors.selected}`,
            fontWeight: theme.font.weight.bold,
        },
    },
    withIcon: {
        padding: toCssValue([0, theme.space.padding.smallest]),
        lineHeight: 1.2,
    },
});
const MenuItem = ({ menuItems, handleGuard, classes, testId = 'MenuItem' }) => menuItems &&
    menuItems.map((menuItem) => (React.createElement(Text, { size: 21, className: classes.menuSection, key: menuItem.path, testId: `${menuItem.testId || testId}-item` },
        React.createElement(NavLink, { "data-testid": `${menuItem.testId || testId}-link`, onClick: menuItem.guardFn ? handleGuard(menuItem.guardFn, menuItem.path) : null, isActive: menuItem.isActive, to: menuItem.path, activeClassName: "selected", className: classes.menuLink },
            menuItem.icon,
            React.createElement("span", { "data-testid": `${menuItem.testId || testId}-label`, className: cn(menuItem.icon && classes.withIcon) }, menuItem.label)))));
const Menu = (props) => {
    const { children, classes, zIndex, testId = 'Menu', className: classNameProp } = props;
    const className = cn(classes.root, classNameProp);
    return (React.createElement("nav", { "data-testid": testId },
        React.createElement(AppBar, { style: { zIndex }, className: className },
            React.createElement(Toolbar, { className: classes.menuContainer },
                MenuItem(props),
                children))));
};
const ComposedMenu = compose(withStyles(styles, { withTheme: true }), pure, defaultProps({ zIndex: 0 }), withHandlers({
    handleGuard: () => (fn, path) => (event) => {
        fn(path);
        event.preventDefault();
        event.stopPropagation();
    },
}))(Menu);
ComposedMenu.displayName = 'AppMenu';
export default ComposedMenu;
//# sourceMappingURL=Menu.js.map